import React, { useEffect, useState, useRef } from "react";
import "./landingpage.css";
import { Link } from "react-router-dom";
import { Header } from "../PageTemplate/Header";
import { Footer } from "../PageTemplate/Footer";
import trustBg from "../../assets/BG-2.png";
import speakerHeroBg from "../../assets/BG-3.png";
import demoImg from "../../assets/Demoimg.png";
import imgUTT from "../../assets/utt.png";
import imgLearnTT from "../../assets/LearnTT.png";
import imgIGov from "../../assets/igov.png";
import imgACTT from "../../assets/actt.png";
import imgNESC from "../../assets/nesc.png";
import imgYTEPP from "../../assets/ytepp.png";
import imgMIC from "../../assets/mic.png";
import imgCOSTAATT from "../../assets/costaatt.png";
import imgUWI from "../../assets/uwi.png";
import imgUSC from "../../assets/usc.png";
import Niherst from "../../assets/niherst.png";
import issuersIcon from "../../assets/icons/issuers.svg";
import holderIcon from "../../assets/icons/holder.svg";
import verifiersIcon from "../../assets/icons/verifiers.svg";
import zeroFraudIcon from "../../assets/icons/zero-fraud.svg";
import zeroWaitIcon from "../../assets/icons/zero-wait.svg";
import zeroCostIcon from "../../assets/icons/zero-cost.svg";

const TRUST_INSTITUTIONS = [
	{
		img: imgUTT,
		alt: "University of Trinidad and Tobago",
		title: "University of Trinidad and Tobago",
		text: "Download Graduation Credentials using student details",
	},
	{
		img: imgUWI,
		alt: "UWI",
		title: "UWI",
		text: "University of the West Indies (UWI) is a premier institution of higher learning in the Caribbean.",
	},
	{
		img: imgUSC,
		alt: "University of the Southern Caribbean",
		title: "University of the Southern Caribbean",
		text: "The University of the Southern Caribbean offers holistic education, preparing students for service to God and humanity.",
	},
	{
		img: Niherst,
		alt: "NIHERST",
		title: "NIHERST",
		text: "The National Institute of Higher Education, Research, Science and Technology (NIHERST) promotes and facilitates the development of science, technology, and innovation in Trinidad and Tobago.",
	},
	{
		img: imgLearnTT,
		alt: "LearnTT",
		title: "LearnTT",
		text: "Empowering Our Citizens. Strengthening Our Future.",
	},
	{
		img: imgIGov,
		alt: "iGovTT",
		title: "iGovTT",
		text: "State-owned enterprise responsible for providing innovative and impactful ICT solutions.",
	},
	{
		img: imgACTT,
		alt: "The Accreditation Council of Trinidad and Tobago",
		title: "The Accreditation Council of Trinidad and Tobago",
		text: "The regulatory authority with responsibility for the quality assurance of post secondary & tertiary education & training.",
	},
	{
		img: imgNESC,
		alt: "NESC Technical Institute",
		title: "NESC Technical Institute",
		text: "Career success starts here. Learn a skill.",
	},
	{
		img: imgYTEPP,
		alt: "YTEPP",
		title: "YTEPP",
		text: "The Youth Training and Employment Partnership Programme (YTEPP).",
	},
	{
		img: imgMIC,
		alt: "Metal Industries Company Limited",
		title: "Metal Industries Company Limited",
		text: "Providing technical and vocational education, training, and advanced manufacturing services.",
	},
	{
		img: imgCOSTAATT,
		alt: "COSTAATT",
		title: "COSTAATT",
		text: "College of Science Technology and Applied Arts of Trinidad and Tobago (COSTAATT).",
	},
	{
		img: imgUTT,
		alt: "University of Trinidad and Tobago",
		title: "University of Trinidad and Tobago",
		text: "Download Graduation Credentials using student details.",
	},
	{
		img: imgUWI,
		alt: "University of the West Indies (UWI)",
		title: "University of the West Indies (UWI)",
		text: "University of the West Indies (UWI) is a premier institution of higher learning in the Caribbean.",
	},
	{
		img: imgUSC,
		alt: "University of the Southern Caribbean",
		title: "University of the Southern Caribbean",
		text: "The University of the Southern Caribbean offers holistic education, preparing students for service to God and humanity.",
	},
	{
		img: Niherst,
		alt: "NIHERST",
		title: "NIHERST",
		text: "The National Institute of Higher Education, Research, Science and Technology (NIHERST) promotes and facilitates the development of science, technology, and innovation in Trinidad and Tobago.",
	},
	{
		img: imgLearnTT,
		alt: "LearnTT",
		title: "LearnTT",
		text: "Empowering Our Citizens. Strengthening Our Future.",
	},
	{
		img: imgIGov,
		alt: "iGovTT",
		title: "iGovTT",
		text: "State-owned enterprise responsible for providing innovative and impactful ICT solutions.",
	},
	{
		img: imgACTT,
		alt: "The Accreditation Council of Trinidad and Tobago",
		title: "The Accreditation Council of Trinidad and Tobago",
		text: "The regulatory authority with responsibility for the quality assurance of post secondary & tertiary education & training.",
	},
	{
		img: imgNESC,
		alt: "NESC Technical Institute",
		title: "NESC Technical Institute",
		text: "Career success starts here. Learn a skill.",
	},
	{
		img: imgYTEPP,
		alt: "YTEPP",
		title: "YTEPP",
		text: "The Youth Training and Employment Partnership Programme (YTEPP)",
	},
	{
		img: imgMIC,
		alt: "Ministry of Digital Transformation",
		title: "Ministry of Digital Transformation",
		text: "Driving Trinidad and Tobago's digital future.",
	},
	{
		img: imgCOSTAATT,
		alt: "COSTAATT",
		title: "COSTAATT",
		text: "College of Science Technology and Applied Arts of Trinidad and Tobago (COSTAATT).",
	},
];

const LandingPage = () => {
	const [ctaLinks, setCtaLinks] = useState({
		issuanceUrl: "#",
		graduatesUrl: "#",
		verifiersUrl: "#",
	});
	const [highlightIndex, setHighlightIndex] = useState(0);
	const [isHighlightHidden, setIsHighlightHidden] = useState(false);
	const [isVideoPlaying, setIsVideoPlaying] = useState(false);
	const iframeRef = useRef(null);
	const words = [
		"Digital Verifiable Credentials",
		"Trusted Credential Exchange",
		"Digital Public Infrastructure",
	];

	// Set CTA links based on host/env
	useEffect(() => {
		if (typeof window === "undefined") return;

		const host = window.location.host || "dev-verifytt.gov.tt";
		// const host = "dev-verifytt.gov.tt";
		let envDomain = "";

		if (host.indexOf("dev-verifytt.gov.tt") !== -1) {
			envDomain = "dev-verifytt.gov.tt";
		} else if (host.indexOf("verifytt.gov.tt") !== -1) {
			envDomain = "verifytt.gov.tt";
		} else {
			const parts = host.split(".");
			if (parts.length > 2) {
				envDomain = parts.slice(parts.length - 3).join(".");
			} else {
				envDomain = host;
			}
		}

		const issuanceUrl = `https://issuance.${envDomain}/`;
		const graduatesUrl = `https://${envDomain}/issuers`;
		const verifiersUrl = `https://verify.${envDomain}/`;

		setCtaLinks({ issuanceUrl, graduatesUrl, verifiersUrl });

		console.log("CTA links:", {
			issuanceUrl,
			graduatesUrl,
			verifiersUrl,
		});
	}, []);

	// Hero highlight word animation
	useEffect(() => {
		let timeoutId;
		const intervalId = setInterval(() => {
			setIsHighlightHidden(true);

			timeoutId = setTimeout(() => {
				setHighlightIndex((prev) => (prev + 1) % words.length);
				setIsHighlightHidden(false);
			}, 250); // match CSS transition
		}, 1400);

		return () => {
			clearInterval(intervalId);
			if (timeoutId) clearTimeout(timeoutId);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleStartVideo = () => {
		if (!iframeRef.current) return;
		const iframe = iframeRef.current;
		const baseSrc = iframe.getAttribute("data-src") || "";

		if (!iframe.src && baseSrc) {
			iframe.src =
				baseSrc +
				(baseSrc.includes("?") ? "&autoplay=1" : "?autoplay=1");
		} else if (iframe.src && !/autoplay=1/.test(iframe.src)) {
			iframe.src =
				iframe.src +
				(iframe.src.includes("?") ? "&autoplay=1" : "?autoplay=1");
		}

		// 👇 tell React we're now "playing"
		setIsVideoPlaying(true);
	};

	return (
		<div>
			{/* HEADER */}
			<Header />
			<div className="lp-hero-row">
				<div className="lp-hero-col">
					<div className="lp-hero-outer">
						<div className="lp-hero-inner">
							<div className="lp-banner">
								<div className="lp-banner-text-group">
									<div
										className="lp-banner-pill"
										aria-label="Tagline"
									>
										<img
											src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/TinyLogo.svg"
											height={20}
											alt="Tiny logo"
										/>
										<div className="lp-banner-pill-text">
											Smart, secure, and future-ready
											digital verification for everyone.
										</div>
									</div>

									<div
										className="lp-banner-heading-wrapper"
										aria-label="Highlight"
										data-property-1="Tex-1"
									>
										<div className="lp-banner-heading">
											<div className="lp-banner-heading-main">
												The National Standard for
											</div>
											<div
												className={
													"lp-banner-heading-highlight" +
													(isHighlightHidden
														? " is-hidden"
														: "")
												}
											>
												{words[highlightIndex]}
											</div>
										</div>
									</div>

									<div className="lp-banner-subtext-wrapper">
										<div
											className="lp-banner-subtext"
											aria-label="Banner description"
										>
											Your official documents are no
											longer just paper. VerifyTT gives
											you a secure, portable, and
											instantly verifiable digital record
											at your fingertips.
										</div>
									</div>
								</div>

								{/* CTAs – 3 buttons in one row, responsive text */}
								<div className="lp-banner-cta-row">
									<Link
										to={ctaLinks.issuanceUrl}
										id="vtIssuersLink"
										target="_blank"
										rel="noreferrer"
										className="lp-banner-cta-link"
										aria-label="Issuers — opens in a new tab"
									>
										<div
											className="lp-banner-cta"
											data-property-1="Default"
										>
											<div className="lp-banner-cta-inner">
												<img
													src={issuersIcon}
													alt="Issuers icon"
													className="lp-banner-cta-icon"
												/>
												<div className="lp-banner-cta-text">
													Issuers
													<img
														className="lp-banner-cta-img"
														src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Uparrowicon.svg"
														alt="hover_img"
													/>
												</div>
											</div>
										</div>
									</Link>

									{/* Holders */}
									<Link
										to={ctaLinks.graduatesUrl}
										id="vtGraduatesLink"
										target="_blank"
										rel="noreferrer"
										className="lp-banner-cta-link"
										aria-label="Graduates — opens in a new tab"
									>
										<div
											className="lp-banner-cta"
											data-property-1="Default"
										>
											<div className="lp-banner-cta-inner">
												<img
													src={holderIcon}
													alt="Holders icon"
													className="lp-banner-cta-icon"
												/>
												<div className="lp-banner-cta-text">
													Holders
													<img
														className="lp-banner-cta-img"
														src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Uparrowicon.svg"
														alt="hover_img"
													/>
												</div>
											</div>
										</div>
									</Link>

									{/* Verifiers */}
									<Link
										id="vtVerifiersLink"
										to={ctaLinks.verifiersUrl}
										target="_blank"
										rel="noreferrer"
										className="lp-banner-cta-link"
										aria-label="Verifiers — opens in a new tab"
									>
										<div
											className="lp-banner-cta"
											data-property-1="Default"
										>
											<div className="lp-banner-cta-inner">
												<img
													src={verifiersIcon}
													alt="Verifiers icon"
													className="lp-banner-cta-icon"
												/>
												<div className="lp-banner-cta-text">
													Verifiers
													<img
														className="lp-banner-cta-img"
														src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Uparrowicon.svg"
														alt="hover_img"
													/>
												</div>
											</div>
										</div>
									</Link>
								</div>
							</div>
						</div>

						{/* ZERO FRAUD, ZERO WAIT, ZERO COST SECTION */}
						<div className="lp-benefits-section">
							<div className="lp-benefits-container">
								<div className="lp-benefits-card">
									<div className="lp-benefit-icon-wrapper">
										<img
											src={zeroFraudIcon}
											alt="Zero Fraud"
											className="lp-benefit-icon"
										/>
									</div>
									<div className="lp-benefit-content">
										<div className="lp-benefit-title">
											Zero Fraud
										</div>
										<div className="lp-benefit-text">
											Tamper-proof credentials secured by
											digital trust
										</div>
									</div>
								</div>

								<div className="lp-benefits-card">
									<div className="lp-benefit-icon-wrapper">
										<img
											src={zeroWaitIcon}
											alt="Zero Wait"
											className="lp-benefit-icon"
										/>
									</div>
									<div className="lp-benefit-content">
										<div className="lp-benefit-title">
											Zero Wait
										</div>
										<div className="lp-benefit-text">
											Real-time verification and
											validation
										</div>
									</div>
								</div>

								<div className="lp-benefits-card">
									<div className="lp-benefit-icon-wrapper">
										<img
											src={zeroCostIcon}
											alt="Zero Cost"
											className="lp-benefit-icon"
										/>
									</div>
									<div className="lp-benefit-content">
										<div className="lp-benefit-title">
											Zero Guesswork
										</div>
										<div className="lp-benefit-text">
											Know instantly whether a credential
											is authentic.
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* HERO VIDEO CARD */}
			{/* <div
					className="vt-video-card"
					onClick={handleStartVideo}
					role="button"
					tabIndex={0}
					aria-label="Play demo video"
					aria-controls="vtDemoVideo"
				>
					<div className="vt-video-card-bg" />

					<div className="vt-video-bg-video">
						<iframe
							id="vtDemoVideo"
							ref={iframeRef}
							data-src="https://www.youtube.com/embed/p6oro5MYtHc?si=gHsx-qF2K5VrvG-U&mute=1&playsinline=1"
							title="YouTube video player"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							referrerPolicy="strict-origin-when-cross-origin"
							allowFullScreen
							aria-label="VerifyTT demo video"
						/>
					</div> */}

			{/* Dark overlay – make it faint when video is playing */}
			{/* <div
						className="vt-video-overlay"
						style={
							isVideoPlaying
								? { opacity: 0.05, pointerEvents: "none" }
								: undefined
						}
						aria-hidden={isVideoPlaying}
					/> */}

			{/* ⬇️ Only show text + pill BEFORE playing */}
			{/* {!isVideoPlaying && (
						<div className="vt-video-card-content">
							<div className="vt-video-card-text-group">
								<div className="vt-video-card-tag">
									Demo Video
								</div>
								<div className="vt-video-card-title">
									How VerifyTT Protects Your Identity and
									Credentials.
								</div>
							</div>

							<div
								className="ie-play-pill"
								onClick={(e) => {
									e.stopPropagation();
									handleStartVideo();
								}}
								role="button"
								tabIndex={0}
								aria-label="Play demo video"
							>
								<div className="ie-play-icon-wrapper">
									<div className="ie-play-icon-inner">
										<img
											src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Play.svg"
											alt="play"
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</div> */}

			{/* LAUNCH RECAP SECTION */}
			<div className="flex w-full justify-center px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8 lg:pb-24">
				<div
					className="relative w-full max-w-[1204px] overflow-hidden rounded-[28px] border border-[#34405D] bg-[#08111F] bg-cover bg-center bg-no-repeat shadow-[0_16px_40px_rgba(15,23,42,0.16)]"
					style={{ backgroundImage: `url(${speakerHeroBg})` }}
				>
					<div className="relative z-10 flex flex-col justify-between gap-8 px-6 py-10 sm:px-8 sm:py-12 lg:flex-row lg:items-center lg:px-12 lg:py-14 xl:px-14">
						<div className="max-w-[640px]">
							<span className="inline-flex w-fit items-center rounded-full border border-white/10 bg-[rgba(128,151,208,0.12)] px-4 py-2 text-[14px] font-semibold uppercase tracking-[0.02em] text-[#56BCF8] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)]">
								VerifyTT Launch Recap
							</span>
							<h2 className="mb-0 mt-6 text-[36px] font-bold leading-[1.08] tracking-[-0.03em] text-white sm:text-[42px] lg:text-[48px]">
								We launched.{" "}
								<span className="text-[#387FF5]">
									See what happened.
								</span>
							</h2>
							<p className="mb-0 mt-5 text-[16px] leading-[1.55] text-white/80">
								On April 22nd, 2026, VerifyTT was officially
								launched at the Hyatt Regency. Watch the
								highlights, hear from the speakers, and explore
								what was revealed on the day.
							</p>
						</div>
						<div className="flex shrink-0 items-center">
							<Link
								to="/event"
								className="inline-flex min-h-[50px] items-center justify-center rounded-[10px] border border-white bg-white px-7 py-3 text-[16px] font-semibold text-[#1A2236] no-underline shadow-[0_10px_22px_rgba(255,255,255,0.08)] transition-all hover:bg-[#F4F7FB]"
							>
								View Recap &#8594;
							</Link>
						</div>
					</div>
				</div>
			</div>

			{/* STRANGER ECONOMY SECTION */}
			<div className="vt-stranger-wrapper">
				<div className="vt-stranger-card">
					<div className="vt-stranger-content">
						{/* LEFT TEXT BLOCK */}
						<div className="vt-stranger-left">
							<div className="vt-stranger-title">
								<span className="vt-stranger-title-main">
									Conquering the <br />
								</span>
								<span className="vt-stranger-title-strong">
									Stranger Economy.
								</span>
							</div>
							<div className="vt-stranger-text">
								In a world full of fakes and misinformation,
								trust is the hardest currency to earn. VerifyTT
								replaces slow, manual verification with a
								secure, real-time system you can rely on.
							</div>
						</div>

						{/* RIGHT CARDS */}
						<div className="vt-stranger-right">
							{/* Card 1 */}
							<div className="vt-stranger-pill">
								<div className="vt-stranger-pill-icon">
									<img
										src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Authentic.svg"
										alt="Authentic"
									/>
								</div>
								<div className="vt-stranger-pill-body">
									<div className="vt-stranger-pill-title">
										Authentic
									</div>
									<div className="vt-stranger-pill-text">
										Issued directly by trusted institutions
									</div>
								</div>
							</div>

							{/* Card 2 */}
							<div className="vt-stranger-pill">
								<div className="vt-stranger-pill-icon">
									<img
										src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Secure.svg"
										alt="Secure"
									/>
								</div>
								<div className="vt-stranger-pill-body">
									<div className="vt-stranger-pill-title">
										Secure
									</div>
									<div className="vt-stranger-pill-text">
										Protected by national-grade encryption
									</div>
								</div>
							</div>

							{/* Card 3 */}
							<div className="vt-stranger-pill">
								<div className="vt-stranger-pill-icon">
									<img
										src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Instant.svg"
										alt="Instant"
									/>
								</div>
								<div className="vt-stranger-pill-body">
									<div className="vt-stranger-pill-title">
										Instant
									</div>
									<div className="vt-stranger-pill-text">
										Digitally verified in seconds
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="vt-stranger-overlay" />
				</div>
			</div>

			{/* THREE PILLARS CARDS */}
			<div className="vt-pillars-section">
				<div className="vt-pillars-container">
					{/* Issuers Card */}
					<div className="vt-pillar-card">
						<div className="vt-pillar">
							<div className="vt-pillar-icon-wrapper">
								<div className="vt-pillar-icon-circle" />
								<div className="vt-pillar-icon vt-pillar-icon-issuers">
									<img
										className="vt-pillar-icon-img-default"
										src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Trust.svg"
										alt="Issuers"
									/>
									<img
										className="vt-pillar-icon-img-hover"
										src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Trust_card_1.svg"
										alt="Issuers hover"
									/>
								</div>
							</div>

							<div className="vt-pillar-content">
								<div className="vt-pillar-header">
									<div className="vt-pillar-label">
										Issuers
									</div>
									<div className="vt-pillar-title">
										Issue Trust. <br />
										Go Digital
									</div>
								</div>
								<div className="vt-pillar-text">
									Join the national standard. Issue
									tamper-proof digital credentials that
									enhance your institution&apos;s global
									reputation and reduce administrative burden
								</div>
							</div>
							<Link to="/issuer">
								<div className="vt-pillar-cta">
									<div className="vt-pillar-cta-inner">
										<div className="vt-pillar-cta-text">
											For Institutions
											<img
												className="vt-pillar-cta-arrow"
												src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/issuer_arrow.svg"
												alt="For Institutions"
											/>
										</div>
									</div>
								</div>
							</Link>
						</div>
					</div>

					{/* Graduates Card */}
					<div className="vt-pillar-card">
						<div className="vt-pillar">
							<div className="vt-pillar-icon-wrapper">
								<div className="vt-pillar-icon-circle" />
								<div className="vt-pillar-icon vt-pillar-icon-graduates">
									<img
										className="vt-pillar-icon-img-default"
										src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Achievements.svg"
										alt="Graduates"
									/>
									<img
										className="vt-pillar-icon-img-hover"
										src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/card_hover_img_1.svg"
										alt="Graduates hover"
									/>
								</div>
							</div>

							<div className="vt-pillar-content">
								<div className="vt-pillar-header">
									<div className="vt-pillar-label">
										Graduates
									</div>
									<div className="vt-pillar-title">
										Your Credentials. <br />
										In Your Pocket
									</div>
								</div>
								<div className="vt-pillar-text">
									No more lost certificates or damaged papers.
									Carry your official degrees and documents in
									a secure digital wallet. Be authentic. Get
									noticed first
								</div>
							</div>
							<Link to="/graduation">
								<div className="vt-pillar-cta">
									<div className="vt-pillar-cta-inner">
										<div className="vt-pillar-cta-text">
											For Credential Holders
											<img
												className="vt-pillar-cta-arrow"
												src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/issuer_arrow.svg"
												alt="For Credential Holders"
											/>
										</div>
									</div>
								</div>
							</Link>
						</div>
					</div>

					{/* Verifiers Card */}
					<div className="vt-pillar-card">
						<div className="vt-pillar">
							<div className="vt-pillar-icon-wrapper">
								<div className="vt-pillar-icon-circle" />
								<div className="vt-pillar-icon vt-pillar-icon-verifiers">
									<img
										className="vt-pillar-icon-img-default"
										src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Verifiers_card_image.svg"
										alt="Verifiers"
									/>
									<img
										className="vt-pillar-icon-img-hover"
										src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/verifiers_card_default_img.svg"
										alt="Verifiers hover"
									/>
								</div>
							</div>

							<div className="vt-pillar-content">
								<div className="vt-pillar-header">
									<div className="vt-pillar-label">
										Verifiers
									</div>
									<div className="vt-pillar-title">
										Know Who’s On The <br />
										Other End.
									</div>
								</div>
								<div className="vt-pillar-text">
									Verify any record—from academic degrees and
									professional certifications to identity
									documents—anywhere, in seconds. Eliminate
									fraud and make decisions with absolute
									certainty.
								</div>
							</div>

							<Link to="/verifier">
								<div className="vt-pillar-cta">
									<div className="vt-pillar-cta-inner">
										<div className="vt-pillar-cta-text">
											For Employers
											<img
												className="vt-pillar-cta-arrow"
												src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/issuer_arrow.svg"
												alt="For Employers"
											/>
										</div>
									</div>
								</div>
							</Link>
						</div>
					</div>
				</div>
			</div>

			{/* BUILDING THE INFRASTRUCTURE OF TRUST SECTION */}
			<div
				className="vt-trust-section"
				aria-label="Trusted institutions carousel"
			>
				<div className="vt-trust-inner">
					<div className="vt-trust-heading-wrapper">
						<div className="vt-trust-heading">
							BUILDING THE INFRASTRUCTURE <br />
							OF TRUST
						</div>
						<div className="vt-trust-marquee">
							<div
								className="vt-trust-cards"
								id="vtTrustCards"
								role="list"
								aria-label="Trusted institutions"
							>
								{TRUST_INSTITUTIONS.map((inst, index) => (
									<div
										key={`${inst.alt}-${index}`}
										className="vt-trust-card vt-trust-card-center"
										role="listitem"
									>
										<img
											className="vt-card-logo-img"
											src={inst.img}
											alt={inst.alt}
										/>
										<div className="vt-trust-card-body">
											<div className="vt-trust-card-title">
												{inst.title}
											</div>
											<div className="vt-trust-card-text-wrapper">
												<div className="vt-trust-card-text">
													{inst.text}
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
			<section
				className="w-full flex justify-center px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20"
				aria-label="Book a demo"
			>
				<div
					className="w-full max-w-[1204px] bg-cover bg-center rounded-2xl overflow-hidden"
					style={{ backgroundImage: `url(${trustBg})` }}
				>
					<div className="flex flex-col-reverse items-center gap-8 p-8 sm:p-10 min-[800px]:flex-row min-[800px]:gap-12 min-[800px]:p-14 lg:p-[70px]">
						{/* Left: text content */}
						<div className="flex flex-col gap-4 w-full min-[800px]:w-1/2">
							<div className="text-[#116DFD] font-semibold text-base tracking-widest uppercase">
								BOOK AN ONBOARDING CONSULTATION
							</div>
							<div className="text-white text-[26px] sm:text-[30px] font-bold leading-tight">
								See VerifyTT In Action?
							</div>
							<div className="text-white text-base leading-[1.7]">
								Discover how VerifyTT makes credentials secure,
								portable, and instantly verifiable. Book an
								onboarding consultation today and see how your
								organization can streamline verification with
								confidence.
							</div>
							<div className="mt-4">
								<a
									href="https://appointments.gov.tt/organizations/appointments/118.110"
									className="inline-block bg-white text-[#0f1623] font-bold text-[15px] px-8 py-[14px] rounded-[10px] no-underline"
								>
									Book Demo
								</a>
							</div>
						</div>
						{/* Right: graphic — hidden on small mobile, smaller on tablet */}
						<div className="hidden sm:flex justify-start items-center w-full min-[800px]:w-1/2 min-[800px]:justify-center">
							<img
								src={demoImg}
								alt="VerifyTT demo graphic"
								className="w-full max-w-[260px] sm:max-w-[320px] md:max-w-[420px] lg:max-w-[480px] h-auto object-contain"
							/>
						</div>
					</div>
				</div>
			</section>
			{/* FOOTER */}
			<Footer />
		</div>
	);
};

export default LandingPage;
